import { Component } from '@angular/core';
import { MiniLayoutWithText } from '@uigy/modules/mini-layout/models/mini-layout';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
    selector: 'app-factory-reset',
    templateUrl: './factory-reset.component.html',
    standalone: false
})
export class FactoryResetComponent {
  public text: MiniLayoutWithText = this.languageService.texts.mini_layout_pages.factory_reset;

  constructor(private languageService: LanguageService) {
  }
}
